<template>
    <div class="content-wrap" v-loading.fullscreen="loading">
        <div class="list-wrap">
            <div class="list-item" v-for="item in list" :key="item.id">
                <img :src="item.image" alt="">
                <div class="content">{{item.desc}}</div>
                <router-link @click.native="show(item)" tag="a" class="link" to="">{{$t('clickEnter')}}</router-link>
            </div>
        </div>
        <message :dialogAdressVisible="dialogAddressShow" @hideDialog="hideDialog"
         :modifyData="modifyData" />

    </div>
</template>

<script>
import message from './dialog.vue'
export default {
    data() {
        return {
            dialogAddressShow: false,
            modifyData:{
                name: ''
            },
            loading: false,
            list: [
                // {id: 1, name:'场馆业务合作', content: "如果您是专业型射箭俱乐部、户外狩猎场，在当地具备一定实力和影响力，并希望在射箭产品、射箭用具、射箭附件、箭馆推广、用户运营等方面与本公司合作。"},


                // {id: 2, name:'渠道销售合作', content: "如果您是射箭器材专卖、户外用品专卖、高端礼品专卖、收藏品专卖、高端人群娱乐用具专卖，在当地具备一定实力和影响力，并希望在射箭产品、射箭附件等方面与本公司合作。"},
                {id: 2, name:'Archery Dealers Cooperation', content: "If you are a local archery dealer who has the local shop and wants to sell our products, please feel free to contact with us for cooperation. "},


                // {id: 3, name:'售后维修合作', content: "如果您是射箭俱乐部、专业玩家，具备复合弓、反曲弓产品及附件等方面的安装、调试、售后、维修方面的能力，并希望在射箭产品的安装、调试、售后、维修等方面与本公司合作。"},
                {id: 3, name:'Warranty Repairing Cooperation', content: "If you are a local dealer or a professional archer, who has the experience with assembling, adjusting and repairing the bows, please feel free to contact with us for cooperation."},

                
                {id: 4, name:'场馆建设合作', content: "如果您有意进入射箭俱乐部行业进行创业或为现有业务增加射箭项目，建设专业型射箭俱乐部、户外狩猎场、体验型射箭馆、植入型射箭馆，并希望本公司向您提供射箭产品、射箭用具、射箭附件、箭馆推广、箭馆运营等方面业务。"},


                // {id: 5, name:'品牌厂商合作', content: "如果您是射箭行业知名制造商，具有极致领先的产品，并愿意以极致的性价比将产品提供给用户，认可三利达的经营理念，希望与本公司合作，共同推广您的产品和服务。"},
                {id: 5, name:'Archery Brands Cooperation', content: "If you are a famous archery brand who has the excellent products at the competitive quotes, and you want to work with us together to promote the products to the customers, please feel free to contact with us for cooperation."},

                
                // {id: 6, name:'用户需求合作', content: "无论您是权威机构、箭馆经营者、教练、运动员、专业玩家、发烧友、制造商、渠道商、售后商等，只要您提出用户需求更能满足用户体验，本公司一定竭尽所能通力合作。"},
                {id: 6, name:'User Requirement Cooperation', content: "No matter you are archery authority, local dealer, archery coach, professional archers, enthusiastic archers, archery manufacturers or any role related to archery, if you have user requirements or any suggestion to meet user exceptions, please feel free to contact with us for cooperation."},
                
                
                // {id: 7, name:'产品研发合作', content: "无论您是权威机构、产品研发机构、材料工艺研发机构、箭馆经营者、教练、运动员、专业玩家、发烧友、制造商、渠道商、售后商等，只要您的技术成果和产品具备领先性，更能够满足用户需求，并愿意与本公司合作。"},
                {id: 7, name:'Archery Design Cooperation', content: "No matter you are archery authority, local dealer, archery coach, professional archers, enthusiastic archers, archery manufacturers or any role related to archery, if you have the advanced design with the archery products to meet user exceptions, please feel free to contact with us for cooperation."},

                
                // {id: 8, name:'配套厂家合作', content: "无论您公司的规模大小，只要具有极致领先的产品，并愿意以极致的性价比将产品供给用户，认可三利达的经营理念，希望与本公司合作，为公司配套或共同推广您的产品和服务。"},
                {id: 8, name:'Support Manufacturers Cooperation', content: "If you are a archery manufacturer who has the excellent products at the competitive quotes, and you want to provide your products to us or work with us together to promote the products to the customers, please feel free to contact with us for cooperation."},

                
                {id: 9, name:'配件加工合作', content: "无论您公司的规模大小，只要贵公司设备精良、工艺领先、质量控制体系完善、供货周期及时，认可三利达的经营理念，愿意以极致的性价比与本公司合作。"},
                // {id: 10, name:'培训教材合作', content: "无论您是权威机构、培训机构、箭馆经营者、教练、运动员、专业玩家、发烧友、制造商、渠道商、售后商等，只要您能独自完成有关不同场景射箭的教材或视频教程，能够让行内专业人士认可，并愿意与本公司合作。"},
                {id: 10, name:'Training Material Cooperation', content: "No matter you are archery authority, local dealer, archery coach, professional archers, enthusiastic archers, archery manufacturers or any role related to archery, only if you can make the training material and videos tutorial which are recognized by the archery professionals, please feel free to contact with us for cooperation."},

                
                // {id: 11, name:'论坛运营合作', content: "无论您是权威机构、箭馆经营者、教练、运动员、专业玩家、发烧友、制造商、渠道商、售后商等，只要您有论坛运营经验和能力，并愿意运营本公司论坛的城市圈子及专业圈子。"},
                {id: 11, name:'Internet Celebrity Cooperation', content: "No matter you are archery authority, local dealer, archery coach, professional archers, enthusiastic archers, only if you are internet celebrity or influencer on YouTube, Tik Tok, Facebook, Instagram or other social media, please feel free to contact with us for cooperation."},

                
                // {id: 12, name:'文化研究合作', content: "本公司愿意与射箭文化研究相关的专家、学者、机构合作，挖掘中国射箭文化，并进行推广和传承，如果您愿意与本公司合作。"}
                {id: 12, name:'Professional Archers Cooperation', content: "If you are a professional archer who attend the archery competitions, please feel free to contact with us for cooperation"}

                
            ]
        }
    },
    components: {
        message
    },
    created() {

        this.$api.coopGetlist({}).then(res => {
            if(res.status) {
                this.list = res.data.list
                // console.log(1212)
            }
        })
        this.loading = true
        setTimeout(() =>{
            this.loading = false
        }, 500)
    },
    methods: {
        show(v) {
            this.modifyData.name = v.form.name
            this.dialogAddressShow = true
        },
        hideDialog() {
            this.dialogAddressShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
.content-wrap {
    background: #ffffff;
    overflow: hidden;
}
.list-wrap {
    width: 1226px;
    margin: 0 auto;
    .list-item{
        float: left;
        margin: 68px 0px 30px 80px;
        .content {
            width: 320px;
            height: 240px;
            line-height: 25px;
            color: #999999;
            font-size: 16px;
            margin: 20px 0px 30px;
        }
        .link {
            display: inline-block;
            width: 180px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            color: #fff;
            font-size: 20px;
            background-color: #F4170E;
            border-radius: 5px;
            margin-left: 60px;
        }
    }
}
</style>